import * as Yup from "yup";

const schema = Yup.object({
  mode: Yup.string().oneOf(["linkExisting", "createNew"]).required(),

  // Link existing
  userId: Yup.number().when("mode", {
    is: "linkExisting",
    then: (s) => s.required("Please select a user"),
    otherwise: (s) => s.optional().nullable(),
  }),

  // Create new
  firstName: Yup.string().when("mode", {
    is: "createNew",
    then: (s) =>
      s
        .trim()
        .matches(/^[A-Za-z\s'-]+$/, "First name can only contain letters")
        .min(2, "At least 2 characters")
        .max(50, "At most 50 characters")
        .required("First name is required"),
    otherwise: (s) => s.optional(),
  }),
  lastName: Yup.string().when("mode", {
    is: "createNew",
    then: (s) =>
      s
        .trim()
        .matches(/^[A-Za-z\s'-]+$/, "Last name can only contain letters")
        .min(1, "At least 1 character")
        .max(50, "At most 50 characters")
        .required("Last name is required"),
    otherwise: (s) => s.optional(),
  }),
  email: Yup.string().when("mode", {
    is: "createNew",
    then: (s) =>
      s
        .email("Invalid email format")
        .matches(/\.[A-Za-z]{2,}$/, "Email must contain a valid domain")
        .required("Email is required"),
    otherwise: (s) => s.optional(),
  }),
  phone: Yup.string().optional(),

  // Shared
  address: Yup.string().nullable().optional(),
  city: Yup.string().nullable().optional(),
  state: Yup.string().nullable().optional(),
  pincode: Yup.string().nullable().optional(),
  bloodGroup: Yup.string().nullable().optional(),
  departmentId: Yup.number().nullable().optional(),
  designationId: Yup.number().nullable().optional(),
  employmentCategoryId: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value,
    )
    .typeError("Employment category is required")
    .required("Employment category is required")
    .positive("Employment category is required"),
  joinDate: Yup.string().required("Join date is required"),
  avatar: Yup.mixed().nullable().optional(),
});

export default schema;
